<!-- Loading -->
<div class="bio-loading" *ngIf="carregando">
  <div class="spinner"></div>
</div>

<!-- Erro / 404 -->
<div class="bio-error" *ngIf="!carregando && erro">
  <div class="error-content">
    <i class="fas fa-exclamation-circle"></i>
    <h2>Pagina nao encontrada</h2>
    <p>A pagina Bio que voce esta procurando nao existe ou foi desativada.</p>
    <a href="/" class="btn-voltar">Voltar ao inicio</a>
  </div>
</div>

<!-- Bio Page -->
<div class="bio-desktop-wrapper" *ngIf="!carregando && !erro && bioPagina">
<div class="bio-page"
     [style.backgroundColor]="bioPagina.corFundo || '#FFF8F0'"
     [style.fontFamily]="bioPagina.fonte ? bioPagina.fonte + ', system-ui, sans-serif' : null"
     [ngClass]="{'heatmap-ativo': modoHeatmap}">

  <!-- HEADER -->
  <header class="bio-header">
    <!-- Logo -->
    <div class="bio-logo-container">
      <img *ngIf="bioPagina.urlLogo"
           [src]="'/images/empresa/' + bioPagina.urlLogo"
           [alt]="bioPagina.titulo"
           class="bio-logo" />
      <div *ngIf="!bioPagina.urlLogo" class="bio-logo-placeholder">
        <i class="fas fa-store"></i>
      </div>
    </div>

    <!-- Name -->
    <h1 class="bio-name" [style.color]="bioPagina.corTexto || '#333'">
      {{bioPagina.titulo}}
    </h1>

    <!-- Subtitle -->
    <p class="bio-subtitle" *ngIf="bioPagina.subtitulo"
       [style.color]="bioPagina.corSecundaria || '#666'">
      {{bioPagina.subtitulo}}
    </p>

    <!-- Address -->
    <p class="bio-address" *ngIf="bioPagina.empresa?.endereco"
       [style.color]="bioPagina.corSecundaria || '#666'">
      <i class="fas fa-map-marker-alt"></i>
      {{bioPagina.empresa.endereco}}
    </p>

    <!-- Status badge -->
    <div class="bio-status" *ngIf="bioPagina.empresa">
      <span class="status-badge"
            [ngClass]="{'aberto': statusLoja.aberto, 'fechado': !statusLoja.aberto}"
            [style.borderRadius.px]="bioPagina.borderRadius">
        <span class="status-dot"></span>
        {{statusLoja.texto}}
      </span>
      <span class="pedido-minimo" *ngIf="bioPagina.empresa?.pedidoMinimo > 0">
        Pedido minimo R$ {{bioPagina.empresa.pedidoMinimo | number:'1.2-2'}}
      </span>
    </div>
  </header>

  <!-- OFFERS CAROUSEL -->
  <section class="bio-ofertas" *ngIf="bioPagina.exibirOfertas !== false && ofertasAtivas.length > 0">
    <div class="ofertas-header">
      <h3 class="ofertas-titulo" [style.color]="bioPagina.corTexto || '#333'">
        Ofertas do Cardapio
      </h3>
      <span class="ofertas-counter" *ngIf="totalOfertas > 1">
        {{ofertaAtual + 1}}/{{totalOfertas}}
      </span>
    </div>

    <div class="ofertas-carousel"
         [style.borderRadius.px]="bioPagina.borderRadius"
         (touchstart)="onTouchStart($event)"
         (touchend)="onTouchEnd($event)">
      <div class="ofertas-track"
           [style.transform]="'translateX(-' + (ofertaAtual * 100) + '%)'">
        <div class="oferta-slide" *ngFor="let oferta of ofertasAtivas; let i = index">
          <div class="oferta-card" (click)="registrarClique('oferta', oferta.id, oferta.urlAcao, oferta.titulo, i)"
               [attr.data-heatmap]="'oferta_' + oferta.id"
               [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
               [style.borderRadius.px]="bioPagina.borderRadius">
            <div class="oferta-thumb" *ngIf="oferta.urlImagem">
              <img [src]="'/images/empresa/' + oferta.urlImagem" [alt]="oferta.titulo" loading="lazy" />
              <span class="oferta-badge" *ngIf="oferta.textoBadge">{{oferta.textoBadge}}</span>
            </div>
            <div class="oferta-info">
              <h4 class="oferta-nome" [style.color]="bioPagina.corTexto || '#333'">{{oferta.titulo}}</h4>
              <p class="oferta-descricao" *ngIf="oferta.descricao"
                 [style.color]="bioPagina.corSecundaria || '#666'">{{oferta.descricao}}</p>
              <div class="oferta-precos">
                <span class="preco-novo">
                  R$ {{oferta.precoPromocional | number:'1.2-2'}}
                </span>
                <span class="preco-antigo" *ngIf="oferta.precoOriginal">
                  R$ {{oferta.precoOriginal | number:'1.2-2'}}
                </span>
              </div>
              <button class="oferta-btn-pedir"
                      (click)="registrarClique('oferta', oferta.id, oferta.urlAcao, oferta.titulo, i); $event.stopPropagation()"
                      [style.backgroundColor]="bioPagina.corBotaoCta || bioPagina.corPrimaria || '#E53935'"
                      [style.borderRadius.px]="bioPagina.borderRadius">
                <i class="fas fa-shopping-bag"></i> Pedir Agora
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dots -->
    <div class="ofertas-dots" *ngIf="totalOfertas > 1">
      <span *ngFor="let oferta of ofertasAtivas; let i = index"
            class="dot"
            [ngClass]="{'active': i === ofertaAtual}"
            (click)="irParaOferta(i)">
        <span class="dot-progress" *ngIf="i === ofertaAtual && timerAutoPlay"></span>
      </span>
    </div>
  </section>

  <!-- PROMO BADGE -->
  <div class="bio-promo-badge" *ngIf="bioPagina.textoBadgePromocional">
    <span class="promo-text">{{bioPagina.textoBadgePromocional}}</span>
  </div>

  <!-- LINKS -->
  <section class="bio-links" *ngIf="linksAtivos.length > 0">

    <!-- CTA Principal (primeiro link) -->
    <div class="link-wrapper" *ngIf="linkCta">
      <div class="link-etiqueta" *ngIf="linkCta.etiqueta && !modoHeatmap"
           [style.backgroundColor]="bioPagina.corPrimaria || '#E53935'">
        <i class="fas fa-tag"></i> {{linkCta.etiqueta}}
      </div>
      <a class="link-card link-cta"
         [attr.data-heatmap]="'link_' + linkCta.id"
         (click)="registrarClique('link', linkCta.id, linkCta.url, linkCta.titulo, 0)"
         [style.borderColor]="bioPagina.corPrimaria || '#E53935'"
         [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
         [style.borderRadius.px]="bioPagina.borderRadius">
        <div class="link-icon-wrapper cta-icon"
             [style.backgroundColor]="(bioPagina.corPrimaria || '#E53935') + '15'">
          <img *ngIf="linkCta.urlIconeCustomizado" [src]="linkCta.urlIconeCustomizado" class="link-custom-icon" alt="" />
          <i *ngIf="!linkCta.urlIconeCustomizado"
             [class]="obtenhaIconeDoTipo(linkCta.tipo)"
             [style.color]="bioPagina.corPrimaria || '#E53935'"></i>
        </div>
        <div class="link-content">
          <strong class="link-title" [style.color]="bioPagina.corPrimaria || '#E53935'">
            {{linkCta.titulo}}
          </strong>
          <span class="link-subtitle" *ngIf="linkCta.subtitulo">
            <strong>{{linkCta.subtitulo}}</strong>
          </span>
        </div>
        <i class="fas fa-chevron-right link-chevron"
           [style.color]="bioPagina.corPrimaria || '#E53935'"></i>
      </a>
    </div>

    <!-- Links regulares -->
    <div class="link-wrapper" *ngFor="let link of linksRegulares; let i = index">
      <div class="link-etiqueta" *ngIf="link.etiqueta && !modoHeatmap"
           [style.backgroundColor]="obtenhaCorDoTipo(link.tipo) || bioPagina.corPrimaria || '#455A64'">
        <i class="fas fa-tag"></i> {{link.etiqueta}}
      </div>
      <a class="link-card"
        [attr.data-heatmap]="'link_' + link.id"
        (click)="registrarClique('link', link.id, link.url, link.titulo, i + 1)"
        [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
        [style.borderRadius.px]="bioPagina.borderRadius">
        <div class="link-icon-wrapper"
             [style.backgroundColor]="(obtenhaCorDoTipo(link.tipo) || bioPagina.corPrimaria || '#455A64') + '15'">
          <img *ngIf="link.urlIconeCustomizado" [src]="link.urlIconeCustomizado" class="link-custom-icon" alt="" />
          <i *ngIf="!link.urlIconeCustomizado"
             [class]="obtenhaIconeDoTipo(link.tipo)"
             [style.color]="obtenhaCorDoTipo(link.tipo) || bioPagina.corPrimaria || '#455A64'"></i>
        </div>
        <div class="link-content">
          <strong class="link-title" [style.color]="bioPagina.corTexto || '#333'">{{link.titulo}}</strong>
          <span class="link-subtitle" *ngIf="link.subtitulo"
                [style.color]="bioPagina.corSecundaria || '#666'">{{link.subtitulo}}</span>
        </div>
        <i class="fas fa-chevron-right link-chevron"></i>
      </a>
    </div>
  </section>

  <!-- Heatmap Layer -->
  <ng-container *ngIf="modoHeatmap && indicadoresHeatmap.length > 0">
    <div class="heatmap-camada">
      <div class="heatmap-item"
           *ngFor="let item of indicadoresHeatmap"
           [style.top.px]="item.top"
           [style.left.px]="item.left"
           [style.width.px]="item.width"
           [style.height.px]="item.height"
           [style.backgroundColor]="item.cor"
           [style.borderRadius.px]="item.borderRadius"
           [ngClass]="{'heatmap-top': item.eTopClique}">
        <span class="heatmap-badge" *ngIf="item.quantidade > 0"
              [ngClass]="{'heatmap-badge-top': item.eTopClique}">
          {{item.quantidade}} {{item.quantidade === 1 ? 'clique' : 'cliques'}} · {{item.percentual}}%
        </span>
      </div>
    </div>
  </ng-container>

  <!-- FOOTER -->
  <footer class="bio-footer">
    <!-- Horarios -->
    <div class="horarios-toggle" (click)="toggleHorarios(); registrarClique('horarios', 0, '', 'Horarios de Funcionamento')"
         *ngIf="bioPagina.empresa?.horariosDoServico?.length" [attr.data-heatmap]="'horarios_0'">
      <i class="fas fa-info-circle mr-2"></i>
      Ver horarios de funcionamento
      <i class="fas ml-2" [ngClass]="{'fa-chevron-down': !horariosExpandido, 'fa-chevron-up': horariosExpandido}"></i>
    </div>

    <div class="horarios-tabela" *ngIf="horariosExpandido && bioPagina.empresa?.horariosDoServico"
         [style.backgroundColor]="bioPagina.corFundoCard || '#FFFFFF'"
         [style.borderRadius.px]="bioPagina.borderRadius">
      <div class="horario-linha" *ngFor="let horario of bioPagina.empresa.horariosDoServico">
        <span class="horario-dia">{{horario.servico || horario.dia}}</span>
        <span class="horario-valor">{{horario.descricaoHorario || horario.horario || 'Fechado'}}</span>
      </div>
    </div>

    <!-- Powered by -->
    <div class="bio-powered-by">
      <a href="https://meucardapio.ai" target="_blank" rel="noopener noreferrer">
        Feito com <span class="heart">&#10084;</span> por MeuCardapio.ai
      </a>
    </div>
  </footer>
</div>
</div>
